var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    _vm._l(_vm.dialogs, function (dialog) {
      return +dialog.is_active
        ? _c(
            "div",
            {
              key: dialog.id,
              class: {
                dialog_select: true,
                active: _vm.selectedDialogId === dialog.id,
              },
              on: {
                click: function ($event) {
                  return _vm.selectDialog(dialog.id)
                },
              },
            },
            [
              _vm.displayDetails && _vm.displayDetails.orderId
                ? [
                    _c(
                      "p",
                      [
                        _vm._v(
                          _vm._s(_vm.types[dialog.type_id]) + "\n        "
                        ),
                        dialog.object_id
                          ? _c("strong", [_vm._v(_vm._s(dialog.object_id))])
                          : _vm._e(),
                        _vm._v(" "),
                        dialog.order
                          ? [
                              _c(
                                "span",
                                {
                                  class: {
                                    badge: true,
                                    "badge-warning": dialog.order.status < 0,
                                    "badge-info": dialog.order.status >= 0,
                                  },
                                },
                                [_vm._v(_vm._s(dialog.order.status_label))]
                              ),
                            ]
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isHasNewMessages(dialog)
                          ? _c("span", { staticClass: "badge badge-success" }, [
                              _vm._v("сообщения"),
                            ])
                          : _vm._e(),
                      ],
                      2
                    ),
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.displayDetails && _vm.displayDetails.author
                ? _c("p", [
                    _vm._v(
                      "(" +
                        _vm._s(dialog.user_id) +
                        ")\n      " +
                        _vm._s(
                          (_vm.users && _vm.users[dialog.user_id]) ||
                            "Пользователь"
                        )
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("p", { staticClass: "text-muted text-right chat_date" }, [
                _vm._v(
                  "(U:" +
                    _vm._s(dialog.user_id) +
                    " " +
                    _vm._s(dialog.id) +
                    ")\n      " +
                    _vm._s(_vm.printDate(dialog.created_at, "DD.MM HH:mm"))
                ),
              ]),
            ],
            2
          )
        : _vm._e()
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }